var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['stepper-separator', { completed: _vm.completed }]})
}
var staticRenderFns = []

export { render, staticRenderFns }